import React from 'react'
import {Grid, Paper, makeStyles, withStyles, Avatar, LinearProgress, useTheme, Chip} from '@material-ui/core'
import { Progress } from 'reactstrap';
import _, { isEmpty, isUndefined } from 'lodash'
import { mdiCrownOutline, mdiRun, mdiHumanHandsup,mdiHumanMale   } from '@mdi/js'; 
import Icon from '@mdi/react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { useSelector } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const colors = [
  '#FFD800',
  '#CAC9C7',
  '#D4711D'
]

const genStyles = (index, intervalltype) => {
  return makeStyles({
    deltagareItem: {
      // height: index < 3 ? 220 : 70,
      height: 57,
      backgroundColor: '#09585C80', 
      // backdropFilter: 'blur(10px)',
      overflow: 'hidden'
    },
    MainProgress: {
      position: 'relative',
      backgroundColor: '#09585C80 !important',
      // height: index < 3 ? 60 : 70,
      height:  '57px !important',
      borderRadius:"0",
    },
    deltagareAvatar: {
      // height: index < 3 ? 110 : 40,
      height:  35,
      // width: index < 3 ? 110 : 40,
      width: 35,
      // fontSize: index < 3 ? 50 : 20,
      fontSize:  20,
      // border: index < 3 ? `solid 6px ${colors[index]}` : 'none',
      border: index < 3 ? `solid 3px ${colors[index]}` : 'none',
    },
    deltagareHead: {
      // padding: index < 3 ? 0 : '0 20px',
      padding: '0 20px',
      width: 240,
      overflow: 'hidden'
    },
    deltagareName: {
      margin: 0,
      whiteSpace: 'nowrap',
      color: '#fff',
      // fontSize: index < 3 ? 28 : 16,
      fontSize:  16,
    },
    place: {
      color: index < 3 ? colors[index] : '#FFFFFF4F',
      // fontWeight:  index < 3 ? 500 : 400,
      fontWeight:  400,
      // fontSize: index < 3 ? 20 : 14,
      fontSize: 14,
    },
    total: {
      // fontSize: index < 3 ? '2rem' : '1.45rem',
      fontSize: '1.45rem',
      fontWeight: 500
    },
    total2: {
      // fontSize: index < 3 ? '1rem' : '0.875rem'
      fontSize: '0.875rem'
    },
    totaltext: {
      color: '#fff',
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: intervalltype===2 ? 'space-between' : index < 3 ? 'center' : 'start',
      padding: '0 1.25rem',
    },
    totaltext2: {
      // paddingTop:  index < 3 ? '22px' : 10,
      // paddingTop:  10,
      color: '#fff',
      width: '100%',
      top: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: intervalltype===2 ? 'space-between' : 'start',
      padding: '0 1.25rem',
      position: 'relative'
    },
    progressContainer: {
      position: 'relative',
      padding: '0 1.25rem',
      width: '100%',
      // paddingBottom:  index < 3 ? '0.8rem' : '0'
      paddingBottom: '0px'
    },
    colorProg: {
      backgroundColor:'rgb(86, 116, 121)'
    },
    rootProg: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: '#FFFFFF4F',
    },
    prog90: {
      backgroundColor: '#66bb6a',
    },
    prog50: {
      backgroundColor: '#009688',
    },
    prog30: {
      backgroundColor: '#ffa726',
    },
    crown:  {
      position: 'absolute',
      // left: '2px',
      // top: '-26px'
      left: '2px',
      top: '0'
    },
    running: {
      position: 'absolute',
      top: '-8px',
      zIndex: 1
    },
    runCont: {
      // overflowX: 'hidden'
    }
  })
}

function ProgressItem({intl,type, total, endSum, leadingValue, classes, intervalltype, _index, tag,Keyword,Color}) {

  const formatNumber=(number)=>{
    if(number > 1000000){
        return `${(number/1000).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}K`
    }else if(number >= 1000){
        return `${(number/1000).toFixed(0)}K`
    }else{
        return number
    }
  }

  const returnValueProgress = (value) => {
    if(parseInt(value) === 0) {
      return 0
    } 
    if(parseInt(intervalltype) === 1 || parseInt(intervalltype) === 3) {
      return (value/parseInt(leadingValue)) * 100 > 100 ? 100 : (value/parseInt(leadingValue)) * 100
    }
    else {
      return (value/parseInt(endSum)) * 100 > 100 ? 100 : (value/parseInt(endSum)) * 100
    } 
  }

  const returnProgressClass = (value) => {
    if(value > 90) return classes.prog90
    if(value > 50) return classes.prog50
    if(value > 30) return classes.prog30
    return classes.prog30
  }

  const getTag = () => {
    return <Chip label={Keyword} style={{backgroundColor: Color, color:'#fff', marginBottom: 6}} size="small" />
  }

  const returnValueFormatByTypeTotal = () => {
    switch(type) {
      //Försäljning
      case 1: return formatNumber(total)
      //Bokade möten
      case 2: return `${total} ${intl.formatMessage({ id: 'DashBoard.contest.Book.Short' })}`
      //Taggar
      case 3: return <>{`${total} `}{getTag()}</>
      //Aktiviteter
      case 4: return `${total} ${intl.formatMessage({ id: 'Activities' })}`
      default: return total
    }
  }
  const returnValueFormatByTypeEnd = () => {
    switch(type) {
      case 1: return formatNumber(endSum)
      case 2: return `${endSum} st`
      case 3: return `${endSum} st`
      case 4: return `${endSum} st`
      default: return endSum
    }
  }

  return (
    <div className='w-100 d-flex align-items-center flex-column overflow-hidden'
      style={{height: 57}}
      // style={_index < 3 ? {} : {height: 70}}
    >
      <div className={classes.totaltext2}>
        {/* {
          _index === 0 && 
          <Icon 
          path={mdiCrownOutline}
          size={1.65}
          rotate={-25}
          className={classes.crown}
          color="#FFD800"/>
        } */}
      
        <span className={classes.total}>
          {
            
            returnValueFormatByTypeTotal()
          }
        </span>
        {/* <span className={classes.total}>
          {
            Competition.type === 1?
            formatNumber(deltagare.total)
            :`${deltagare.total} st`
          }
        </span> */}
        {
          intervalltype === 2 &&
          <span className={classes.total}>{returnValueFormatByTypeEnd()}</span>
        }
      </div>
      <div className={classes.progressContainer}>
        <div className={`w-100 position-relative ${classes.runCont}`}>
          {
            returnValueProgress(total) === 100 ?
            <Icon 
            path={mdiHumanHandsup}
            size={1.1}
            rotate={0}
            className={classes.running}
            style={{left: `${99}%`}}
            color="#FFF"/>
            : 
            // returnValueProgress(deltagare.total) === 0 ?
            // <Icon 
            // path={mdiHumanMale}
            // size={1.1}
            // rotate={0}
            // className={classes.running}
            // style={{left: `-22px`}}
            // color="#FFF"/>
            // :
            <Icon 
            path={mdiRun}
            size={1.1}
            rotate={0}
            className={classes.running}
            style={{left: `calc(${returnValueProgress(total)}% - 11px)`}}
            color="#FFF"/>
          }
        </div>
        <LinearProgress 
          variant="determinate" 
          value={returnValueProgress(total)}
          classes={{
            root:classes.rootProg,
            colorPrimary: classes.colorProg,
            bar: returnProgressClass(returnValueProgress(total))
          }}
        />
      </div>
    </div>
  )
}

function DeltagareItem({intl,deltagare, _index,Competition}) {
  const styles = genStyles(_index, Competition.intervalltype)
  const classes = styles()

  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const returnP = (index) => {
    if(index > 1) return 'e'
    else return 'a'
  }

  const formatNumber=(number)=>{
    if(number > 1000000){
        return `${(number/1000).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}K`
    }else if(number >= 1000){
        return `${(number/1000).toFixed(0)}K`
    }else{
        return number
    }
  }

  const returnMaxValue = () => {
    if(parseInt(Competition.intervalltype) === 1) return isEmpty(Competition.compDataArr) ? 0 : parseInt(Competition.compDataArr[0].total)
    else return parseInt(Competition.compEndSum)
  }
  const returnValueProgress = (value) => {
    if(parseInt(value) === 0) return 0
    if(parseInt(Competition.intervalltype) === 1 || parseInt(Competition.intervalltype) === 3) return isEmpty(Competition.compDataArr) ? 100 : (value/parseInt(Competition.compDataArr[0].total)) * 100 > 100 ? 100 : (value/parseInt(Competition.compDataArr[0].total)) * 100
    else return (value/parseInt(Competition.compEndSum)) * 100 > 100 ? 100 : (value/parseInt(Competition.compEndSum)) * 100
  }
  

  const getLeadingValueInType = (_compDataArr, type) => {
    let leadingValue = 0
    for(let d of _compDataArr) {
      let obj = d.deltagarData.find(__d => __d.type === type)
      if(!isUndefined(obj)) {
        if(parseFloat(obj.total) > leadingValue) leadingValue = parseFloat(obj.total)
      }
    }
    return leadingValue
  }

  return (
    <Grid item xs={12}>
      <Paper className={classes.deltagareItem}>
        <div className={`position-relative d-flex align-items-center h-100 w-100 ${'flex-row justify-content-start'}`}
          // style={{paddingBottom: _index < 3 ? 40 : 0}}
          style={{paddingBottom: 0}}
        >
          <div className={`d-flex h-100 align-items-center ` + classes.deltagareHead}>
            <Avatar className={classes.deltagareAvatar} src={deltagare.ProfilePicUrl}>
              { _.upperCase(deltagare.FirstName[0])}
              { _.isEmpty(deltagare.LastName)?"":_.upperCase(deltagare.LastName[0])}
            </Avatar>
            <div className={'pl-3'}>
              <h3 className={classes.deltagareName}>
                {`${deltagare.FirstName} ${deltagare.LastName}`}
              </h3>
              <p className={classes.place}>
                {`${_index + 1 + returnP(_index)}`} <IntlMessages id="DashBoard.contest.placing"/>
              </p>
            </div>

          </div>
          {
            // _index < 3 ? 
            // <div className='w-100' style={{position: 'absolute', bottom: 0, left: 0}}>
            //   <AutoPlaySwipeableViews
            //       disabled
            //       interval={5000}
            //       axis={theme.direction === 'rtl' ? 'y-reverse' : 'y'}
            //       index={activeStep}
            //       onChangeIndex={handleStepChange}
            //       enableMouseEvents
            //       className='w-100'
            //       style={{height: '92px'}}
            //       containerStyle={{height: 92}}
            //     >
            //       {deltagare.deltagarData.map((d, index) => (
            //         <ProgressItem 
            //           {...d}
            //           _index={_index}
            //           leadingValue={getLeadingValueInType(Competition.compDataArr, d.type)}
            //           intervalltype={Competition.intervalltype}
            //           classes={classes}
            //         />
            //       ))}
            //     </AutoPlaySwipeableViews>
            // </div> :
            
          }
          <div className='position-relative w-100' style={{height: 57}}>
            <div className='w-100' style={{position: 'absolute', bottom: 0, left: 0}}>
            <AutoPlaySwipeableViews
                disabled
                interval={5000}
                axis={theme.direction === 'rtl' ? 'y-reverse' : 'y'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
                className='w-100'
                style={{height: 57}}
                containerStyle={{height: 57}}
              >
                {deltagare.deltagarData.map((d, index) => (
                  <ProgressItem 
                    {...d}
                    _index={_index}
                    intl={intl}
                    leadingValue={getLeadingValueInType(Competition.compDataArr, d.type)}
                    intervalltype={Competition.intervalltype}
                    classes={classes}
                  />
                ))}
              </AutoPlaySwipeableViews>
            </div>
          </div>
         
        </div>
        
      </Paper>
    </Grid>
  )
}
export default injectIntl(DeltagareItem);